type ProjectRemovalError = {};

const projectRemovalError: ProjectRemovalError = {};

export type { ProjectRemovalError };

export { projectRemovalError };
